import { RECEIVED_ACTIVITIES } from '../actions/GetActivities';

const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case RECEIVED_ACTIVITIES:
            return action.activities;
        default:
            return state;
    }
};
